import React, { useContext, useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { BackButton } from "../../components/BackButton";
import { Checkbox } from "../../components/Checkbox";
import { Loading } from "../../components/Loading";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { saveStateRemote, submitApplication } from "../../utils/api";
import { trackEvent } from "../../utils/gtm";
import { logError } from "../../utils/log";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";


const ConditionsStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Conditions' } });
    dispatch({ type: "set_step", step: Step.Conditions });
    scrollToTopOfContent();

    const saveState = async () => {
      await saveStateRemote(state);
    };
    saveState();
  }, []);

  const validationSchema = yup.object().shape({
    resursConsent: yup.boolean().oneOf([true], "Husk at acceptere betingelser"),
  });

  return (
    <>
      <h2>Godkend ansøgning</h2>

      <h3>
        Du er nu klar til at godkende ansøgningen
      </h3>

      {errorMessage && (
        <div className="text-center font-bold text-red-700 mt-5">
          {errorMessage}
        </div>
      )}

      <Formik
        initialValues={{
          resursConsent: false,
        }}
        onSubmit={async () => {
          
          setErrorMessage("");

          try {
            await submitApplication(state.applicationId!);
            navigate(`/status?applicationId=${state.applicationId}`);
          } catch (e) {
            setErrorMessage(
              "Der opstod en fejl, prøv igen eller kontakt support"
            );
            logError(e);
          }
        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <div>
            {formikProps.isSubmitting && (
              <div className="mt-5">
                <Loading text="Indsender låneansøgning..." />
              </div>
            )}

            <div className="mt-5">
              <Checkbox
                isStatic={false}
                heading="Jeg accepterer Resurs Banks generelle vilkår"
                checked={formikProps.values.resursConsent}
                isInvalid={formikProps.values.resursConsent !== undefined}
                disabled={formikProps.isSubmitting}
                onChange={(checked) => {
                  formikProps.setValues({
                    ...formikProps.values,
                    resursConsent: checked,
                  });
                }}
              >
                <span className="text-xs inline-block">
                  Resurs Bank (RB) tilbyder en specialkontoordning med
                  fordelagtige gebyrer og renter, når betaling sker i henhold
                  til specialkontoplaner, se vedlagte Standardiserede Europæiske
                  Forbrugerkreditoplysninger (SEF).
                  <br />
                  Sker betalingen ikke i henhold til den valgte afdragsordning,
                  gælder RB's alm. rente- og gebyrbestemmelser (Basiskonto).
                  <br />
                  Renter tilskrives kontoen fra den dag, hvor et køb foretages.
                  <br />
                  <br />
                  Jeg er myndig og erklærer på tro og love at ovenstående
                  oplysninger er korrekte, at den oplyste adresse er min faste
                  bopæl i Danmark, at der må indhentes kreditoplysninger i et
                  kreditoplysningsbureau, samt oplysninger fra CPR-registret, og
                  at disse oplysninger må blive registreret hos RB, samt at jeg
                  skriftligt og på "MineSider" på resursbank.dk har modtaget,
                  læst og godkendt gældende SEF med særlige kontovilkår,
                  "Almindelige kontobetingelser For Private Aftaler Om
                  Kontokredit Samt Privatlån for Danmark", samt kreditaftalen
                  fra RB.
                  <br />
                  <br />
                  Kopi af aftalen, SEF og kontobetingelser er tilgængelige på
                  resursbank.dk.
                  <br />
                  <br />
                  Ved indgåelse af en aftale med RB indgår jeg i RBs
                  kunderegister. Mine personlige oplysninger kan benyttes og
                  distribueres til brug for markedsføring.
                  <br />
                  Jeg kan frabede mig dette ved meddelelse herom til
                  forretningen og/eller RB Kundeservice.
                </span>
                {(formikProps.touched.resursConsent ||
                  formikProps.submitCount > 0) &&
                  formikProps.errors.resursConsent && (
                    <div className="invalid-feedback">
                      {formikProps.errors.resursConsent}
                    </div>
                  )}
              </Checkbox>
            </div>

            <div className="container-btn">
              <BackButton />

              <button
                disabled={formikProps.isSubmitting}
                className="btn-next"
                style={{ width: "170px" }}
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Ok, ansøg
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default ConditionsStep;
